import tokens from './tokens';

const media = {
  mobile: `@media screen and (max-width: ${tokens.breakpoints.mobile})`,
  tablet: `@media screen and (max-width: ${tokens.breakpoints.tablet})`,
  laptop: `@media screen and (max-width: ${tokens.breakpoints.laptop})`,
  desktop: `@media screen and (max-width: ${tokens.breakpoints.desktop})`,
  tabletOnly: `@media screen and (min-width: ${tokens.breakpoints.mobile}) and (max-width: ${tokens.breakpoints.laptop})`,
};

export default media;
